import React from 'react'
import Navbar from '../Navegation/Navbar'
import Footer from '../Navegation/Footer'

function About(){
    const main = {
        backgroundColor: '#efeeea'
    }
    const title = {
        textAlign: 'center',
        fontFamily: 'Stadium',
        fontSize: '12em'
    }
    const info = {
        width: '100%',
        fontFamily: 'SarabunRegular',
        fontSize: '1.2em',
        color: '#181818',
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0% 10%'
    }
    const video = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
        padding: '5%'
    }
    return(
        <>
        <Navbar/>
        <div style={main}>
            <h1 style={title}>NIEBLA</h1>
            <p style={info}>Somos un estudio orientado en la creación de contenido creativo, nos enfocamos en la calidad y originalidad. Producimos, filmamos y editamos.
                Creemos que los mejores proyectos provienen de colaboraciones entre nuestro equipo y el tuyo, es por eso que buscamos trabajar con personas con ideas grandes y creativas.
                Nuestra misión es darle vida a tus proyectos y solucionar problemas de manera creativa.
                ¡Estamos ansiosos de trabajar con ustedes! 
                ¡Contactános hoy!
            </p>
            <div style={video}>
                <iframe width="1200" height="480" src="https://www.youtube.com/embed/TO5WAvlXPS4" title="NO HAY SEÑAL | TRAILER | NIEBLA films" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
        </div>
        <Footer/>
        </>
    )
}
export default About